import { http } from '@/http';
import { CreateCheckoutResponse } from '@/entities/payment';

export const createPaymentCheckout = (
  onboardingUlid: string,
  productId: string,
  successUrl: string,
  failureUrl: string,
) =>
  http.post<CreateCheckoutResponse>('v1/payments/checkout', {
    onboarding_ulid: onboardingUlid,
    product_id: productId,
    success_url: successUrl,
    failure_url: failureUrl,
  });
